export const experience = {
  it: {
    title: "Esperienza",
    techStack: "Stack Tecnologico",
    items: [
      {
        company: "Consulente Indipendente",
        position: "Power Platform, Dati & Automazione",
        period: "2024 - Presente",
        description: "Progetti a prezzo fisso per PMI e system integrator: app gestionali, dashboard e automazioni",
        achievements: [
          "Sviluppo app Power Apps che sostituiscono processi su carta ed Excel",
          "Dashboard Power BI collegate a gestionali, SQL e fogli di calcolo",
          "Automazioni e integrazioni tra sistemi che non si parlano (CRM, ERP, e-commerce)"
        ],
        techStack: "Power Apps, Power Automate, Power BI, SQL Server, Supabase, Azure"
      },
      {
        company: "Baker Hughes",
        position: "Ingegnere del Software",
        period: "2023 - 2024",
        description: "Sviluppato automazione e soluzioni Power Platform per un'azienda enterprise del settore energia",
        achievements: [
          "Supportato oltre 200 processi aziendali critici sulla Power Platform",
          "Progettato applicazioni di approvazione del flusso di lavoro con PowerApps e Power Automate",
          "Automatizzato i processi aziendali riducendo il lavoro manuale del 60%"
        ],
        techStack: "PowerApps, Power Automate, Power BI, SQL Server, Azure AI"
      },
      {
        company: "Pharma Line Srl",
        position: "Sviluppatore Software & IT Helpdesk",
        period: "2021 - 2023",
        description: "Guidato l'automazione e la trasformazione digitale per operazioni farmaceutiche",
        achievements: [
          "Sviluppato applicazioni basate su PowerApps per la gestione delle vendite e degli ordini",
          "Automatizzato migrazioni di database e flussi di lavoro back-end",
          "Costruito dashboard KPI in tempo reale per business intelligence"
        ],
        techStack: "PowerApps, Power BI, SQL Server, PowerShell"
      },
      {
        company: "Angelica Wine Srls",
        position: "Programmatore",
        period: "2019 - 2020",
        description: "Gestito IT, sviluppo e-commerce e trasformazione digitale",
        achievements: [
          "Costruito piattaforme e-commerce personalizzate e strumenti di automazione logistica",
          "Progettato soluzioni di tracciamento dell'inventario e della catena di fornitura basate sul web"
        ],
        techStack: "SQL, Python, Power BI, React.js, API E-Commerce"
      },
      {
        company: "Focaccia Group Automotive Srl",
        position: "Analista Dati",
        period: "2019",
        description: "Sviluppato soluzioni analitiche basate su Power BI ed Excel",
        achievements: [
          "Creato report automatizzati di tracciamento vendite per dashboard dirigenziali",
          "Progettato modelli di previsione per ottimizzare i livelli di stock"
        ],
        techStack: "Power BI, Excel, SQL Server"
      }
    ]
  },
  en: {
    title: "Experience",
    techStack: "Tech Stack",
    items: [
      {
        company: "Independent Consultant",
        position: "Power Platform, Data & Automation",
        period: "2024 - Present",
        description: "Fixed-price projects for SMEs and system integrators: business apps, dashboards and automations",
        achievements: [
          "Building Power Apps that replace paper and Excel-based processes",
          "Power BI dashboards connected to ERPs, SQL and spreadsheets",
          "Automations and integrations between systems that don't talk to each other (CRM, ERP, e-commerce)"
        ],
        techStack: "Power Apps, Power Automate, Power BI, SQL Server, Supabase, Azure"
      },
      {
        company: "Baker Hughes",
        position: "Software Engineer",
        period: "2023 - 2024",
        description: "Developed automation & Power Platform solutions for an enterprise energy company",
        achievements: [
          "Supported 200+ critical business processes on the Power Platform",
          "Designed workflow approval applications using PowerApps & Power Automate",
          "Automated business processes, cutting manual work by 60%"
        ],
        techStack: "PowerApps, Power Automate, Power BI, SQL Server, Azure AI"
      },
      {
        company: "Pharma Line Srl",
        position: "Software Developer & IT Helpdesk",
        period: "2021 - 2023",
        description: "Led automation & digital transformation for pharma operations",
        achievements: [
          "Developed PowerApps-based applications for sales & order management",
          "Automated database migrations & back-end workflows",
          "Built real-time KPI dashboards for business intelligence"
        ],
        techStack: "PowerApps, Power BI, SQL Server, PowerShell"
      },
      {
        company: "Angelica Wine Srls",
        position: "Programmer",
        period: "2019 - 2020",
        description: "Managed IT, e-commerce development, & digital transformation",
        achievements: [
          "Built custom e-commerce platforms & logistics automation tools",
          "Designed web-based inventory & supply chain tracking solutions"
        ],
        techStack: "SQL, Python, Power BI, React.js, E-Commerce APIs"
      },
      {
        company: "Focaccia Group Automotive Srl",
        position: "Data Analyst",
        period: "2019",
        description: "Developed Power BI & Excel-based analytics solutions",
        achievements: [
          "Created automated sales tracking reports for executive dashboards",
          "Designed forecasting models to optimize stock levels"
        ],
        techStack: "Power BI, Excel, SQL Server"
      }
    ]
  }
};